import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import RegistrationSheet from "../components/registration/RegistrationSheet";
import LoadingScreen from "../components/loading/LoadingScreen";
import EmbeddedUrlViewer from "../components/EmbeddedUrlViewer";
import QRCodeViewer from "../components/QRCodeViewer"
import { useTenantStore } from "../stores/TenantStore";
import { LoadingSpinnerType, useConfigurationStore } from "../stores/ConfigStore";
import { Slide, Fade, useMediaQuery, useTheme } from "@mui/material";
import { useThemeStore } from "../stores/ThemeStore";
import ModalContainer from "../components/layout/ModalContainer";
import { width } from "@mui/system";

type Params = {
  tenantId?: string;
  deviceName?: string;
};


interface WrapperProps {
  openLinksInModal: boolean;
  open: boolean;
  positioned: boolean;
  children: React.ReactNode;
}

const ConditionalWrapper: React.FC<WrapperProps> = ({ openLinksInModal, open, children, positioned }) => {
  return openLinksInModal ? (
    <ModalContainer open={open}  positioned={positioned}>
      {children}
    </ModalContainer>
  ) : (
    <Fade in={open} unmountOnExit timeout={500}>
      <div style={{width:"100vw"}}>{children}</div>
    </Fade>
  );
};

const Placeholder: React.FC = () => {
  const { setPrimaryColor } = useThemeStore()
  let navigate = useNavigate();
  const { configuration, dispatchConfiguration } = useConfigurationStore();
  const { setIsRequestPending, activeState } = useTenantStore();
  const { tenantId, deviceName } = useParams<Params>();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (tenantId) dispatchConfiguration({ type: 'SET_TENANT_ID', payload: tenantId });
    if (deviceName) dispatchConfiguration({ type: 'SET_DEVICE_NAME', payload: deviceName });

    searchParams.forEach((value, key) => {
      switch (key) {
        case 'placeholderUrl':
          dispatchConfiguration({ type: 'SET_PLACEHOLDER_URL', payload: decodeURIComponent(value) });
          break;
        case 'companyLogoUrl':
          dispatchConfiguration({ type: 'SET_COMPANY_LOGO_URL', payload: decodeURIComponent(value) });
          break;
        case 'companyName':
          dispatchConfiguration({ type: 'SET_COMPANY_NAME', payload: decodeURIComponent(value) });
          break;
        case 'showLogo':
          dispatchConfiguration({ type: 'SET_SHOW_LOGO', payload: value === 'true' });
          break;
        case 'loadingSpinnerType':
          const spinnerType = Object.values(LoadingSpinnerType).find(type => type === value);
          if (spinnerType) {
            dispatchConfiguration({ type: 'SET_LOADING_SPINNER_TYPE', payload: spinnerType as LoadingSpinnerType });
          }
          break;
        case 'companyHexColor':
          setPrimaryColor(decodeURIComponent(value))
          dispatchConfiguration({ type: 'SET_COMPANY_HEX_COLOR', payload: decodeURIComponent(value) });
          break;
        case 'openLinksInModal':
          dispatchConfiguration({ type: 'SET_OPEN_LINKS_IN_MODAL', payload: value === 'true' });
          break;
        default:
          console.warn(`Unhandled configuration key: ${key}`);
      }

      const target = searchParams.get('IsSetup');
      if (target) {
        navigate('/');
      }/* else{
        navigate(`/${tenantId}/${deviceName}`);
      } */
    });

    setIsRequestPending(true);
  }, [tenantId, deviceName, searchParams, dispatchConfiguration, setIsRequestPending]);

  /*
  Hide Scrollbar for Slide In Effect since the width changes momentarily
  */
  useEffect(() => {
    const hideScrollbarTemporarily = () => {
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        document.body.style.overflow = '';
      }, 1000);
    };

    hideScrollbarTemporarily();
  }, [activeState]);

  return (
    <div style={{ position: 'relative' }}>
      <Slide in={activeState.registrationSheetHasArrived} direction="left" unmountOnExit timeout={1000}>
        <div>
          <RegistrationSheet />
        </div>
      </Slide>

      <ConditionalWrapper
        openLinksInModal={configuration.design.openLinksInModal}
        open={activeState.embeddedHasArrived}
        positioned={true}
      >
        <EmbeddedUrlViewer isModal={configuration.design.openLinksInModal} />
      </ConditionalWrapper>

      <ConditionalWrapper
        openLinksInModal={configuration.design.openLinksInModal}
        open={activeState.qrCodeHasArrived}
        positioned={false}
      >
        <QRCodeViewer isModal={configuration.design.openLinksInModal} />
      </ConditionalWrapper>
      <LoadingScreen isVisible={activeState.emptyResponse} />

    </div>
  );
};
export default Placeholder;